<template>
  <div class="animated fadeIn invoices">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <!-- <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
           <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> 
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="returnModal" width="700">
      <v-card class="dialog-card">
        <v-card-title class="white grey--text text--darken-2 text-center">
          <h4>برگشت فاکتور {{ selected.invoiceCode }} از فروش</h4>
        </v-card-title>
        <hr class="mt-0" />
        <v-card-text>
          <v-container class="mt-4 px-0 pb-0">
            <div class="fs-large d-flex">
              <b class="pe-2">مبلغ قابل بازگشت از فاکتور:</b>
              <span v-if="calculateLoading">
                <half-circle-spinner
                  :animation-duration="1000"
                  :size="25"
                  :color="'#777'"
                />
              </span>
              <span v-else
                >{{ Number(returnAmount).toLocaleString() }} تومان</span
              >
            </div>
            <h5 class="text-right fs-medium mt-4">
              آیا از برگشت فروش ثبت شده اطمینان دارید؟
            </h5>
            <div class="text-left pt-4">
              <v-btn
                class="red-mainBtn white--text mx-1"
                @click="returnModal = false"
                >خیر</v-btn
              >
              <v-btn class="green-mainBtn mx-1" :loading="busy" @click="submit"
                >بله</v-btn
              >
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <loading v-if="vLoading" />

    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2 fs-large">فاکتور فروش</h4>
      </div>
      <hr class="mt-5" />
      <v-card v-if="loading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#7c4dff'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container class="pt-12">
          <v-row>
            <v-col class="d-flex flex-row">
              <h4 class="primary--text">فاکتور فروش فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4"
                >({{ computedInvoices.length }} فاکتور)</span
              >
            </v-col>

            <v-col class="text-sm-left">
              <v-btn
                to="/shop/newInvoice"
                class="purple-borderedBtn"
                height="43"
              >
                <v-icon class="me-1">$Bag</v-icon>
                افزودن فاکتور جدید
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-6">
            <v-col xl="2" lg="2" md="2" sm="6" xs="12">
              <v-select
                dense
                outlined
                hide-details
                :items="types"
                v-model="typeFilter"
                height="45"
                color="#7c4dff"
                @change="currentPage = 1"
                placeholder="فیلتر وضعیت "
                class="d-flex align-center"
              >
              </v-select>
            </v-col>
            <v-col xl="3" lg="3" md="3" sm="6" xs="12">
              <v-text-field
                outlined
                dense
                prepend-inner-icon="search"
                hide-details
                label="جستجو در کد فاکتور..."
                height="45"
                color="#7c4dff"
                @input="currentPage = 1"
                v-model="codeFilter"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="codeFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      codeFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </v-col>
            <v-col xl="3" lg="3" md="3" sm="6" xs="12">
              <v-text-field
                outlined
                dense
                prepend-inner-icon="search"
                hide-details
                label="جستجو در نام مشتری..."
                height="45"
                color="#7c4dff"
                v-model="nameFilter"
                @input="currentPage = 1"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="nameFilter.length"
                    class="red--text text--lighten-2"
                    @click="
                      nameFilter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </v-col>

            <v-col xl="4" lg="4" md="4" sm="6" xs="12">
              <MyCalendar
                @submit="searchInvoices()"
                @getStartDate="getStartDate"
                @getEndDate="getEndDate"
                :label="'فیلتر زمانی'"
                :icon="'arrow'"
                :start="startDate"
                :end="endDate"
                height="45"
                width="100%"
                color="#7c4dff"
              />
            </v-col>
          </v-row>
          <hr class="mt-5" />
          <vue-excel-xlsx
            v-if="computedInvoices.length"
            :data="computedInvoices"
            style="float: left"
            class="darkGreen-mainBtn white--text py-2 px-6 mx-0 mx-md-6 mb-6"
            :columns="excelFields"
            :filename="'فاکتور فروش فروشگاه '"
            sheetname="فاکتور فروش فروشگاه"
          >
            <v-icon class="white--text">mdi-file-excel</v-icon> دریافت اکسل
          </vue-excel-xlsx>
          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedInvoices"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(totalCost)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() + " تومان " }}
                </div>
              </template>

              <template v-slot:cell(type)="data">
                <div style="text-align: center; vertical-align: middle">
                  <div
                    class="mx-auto"
                    :class="
                      data.value == 'حقیقی' ? 'purple-badge' : 'green-badge'
                    "
                  >
                    {{ data.value }}
                  </div>
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="orange-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    class="green-mainBtn mr-1"
                    width="135"
                    height="36"
                    @click="goToId(row.item)"
                    >مشاهده</v-btn
                  >
                  <!-- <v-btn
                
                          class="mr-1"
                          style="background-color: green; color: white"
                          width="135"
                          height="40"
                          @click="goToEditInvoicePage(row.item)"
                        
                          ><v-icon class="me-1"> mdi-pencil-outline </v-icon>
                          ویرایش سفارش
                        </v-btn> -->
                  <v-btn
                    :disabled="gettingReceipt"
                    class="orange-mainBtn mr-1"
                    width="135"
                    height="36"
                    @click="print(row.item, true)"
                    >چاپ رسید</v-btn
                  >
                  <!-- <v-btn
                    class="yellow-mainBtn mx-2"
                    width="135"
                    height="40"
                    @click="$router.push('/shop/editInvoice/' + row.item.id)"
                    ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                    >ویرایش</v-btn
                  > -->
                  <v-btn
                    v-if="row.item.status != 'برگشت خورده'"
                    class="mr-1 red-mainBtn white--text"
                    width="135"
                    height="36"
                    @click="calculateReturnAmount(row.item)"
                    >برگشت از فروش</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6" v-if="computedInvoices.length">
              <v-col xl="12" lg="12" md="12" sm="12" xs="12">
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedInvoices.length / perPage)"
                    :total-visible="5"
                    prev-icon="mdi-arrow-left"
                    next-icon="mdi-arrow-right"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>
    <!-- receipt -->
    <v-card>
      <div id="Receipt" v-show="false" v-if="!gettingReceipt">
        <div class="mainTable" style="width: 100%; height: 100%">
          <div style="margin-bottom: 15px">
            <div style="text-align: center; width: 100%">
              <img src="/pen.png" height="100px" alt="" />
            </div>
          </div>
          <tbody>
            <tr>
              <td>
                <div
                  class="content"
                  style="padding: 5px 0; margin-bottom: 15px"
                >
                  <div>
                    <div>
                      <div style="text-align: center">
                        <strong style="font-size: 17px"
                          >{{ printInvoice.shopCustomerName }} عزیز، از دیدن
                          دوباره شما خوش‌حالیم!</strong
                        >
                      </div>
                      <table
                        v-if="printInvoice.shopCustomerName"
                        style="
                          border: 0px solid black !important;
                          margin-top: 15px;
                        "
                      >
                        <tr>
                          <td style="border: 0px solid black !important">
                            تاریخ خرید:
                            {{ printInvoice.date }}
                          </td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span style="font-size: 16px">
                              {{ printInvoice.code }}
                            </span>
                          </td>
                        </tr>
                      </table>
                      <table
                        v-if="printInvoice.status != 'ثبت شده'"
                        style="border: 0px solid black !important"
                      >
                        <tr>
                          <td style="border: 0px solid black !important"></td>
                          <td
                            style="
                              border: 0px solid black !important;
                              text-align: left;
                            "
                          >
                            <span
                              v-if="printInvoice.status != 'ثبت شده'"
                              style="font-size: 16px; font-weight: bold"
                              >({{ printInvoice.status }})</span
                            >
                          </td>
                        </tr>
                      </table>

                      <br />
                    </div>
                  </div>
                  <b-table
                    v-if="printInvoice.details"
                    bordered
                    :fields="selectedFields"
                    :items="printInvoice.details"
                    small="small"
                    responsive
                  >
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div
                        style="
                          text-align: center;
                          vertical-align: middle;
                          min-width: 300px;
                        "
                      >
                        {{
                          data.value +
                          (data.item.color
                            ? " / رنگ: " + data.item.color
                            : "") +
                          (data.item.size ? " / سایز: " + data.item.size : "") +
                          (data.item.volume
                            ? " / حجم :" + data.item.volume
                            : "") +
                          (data.item.dimension
                            ? " / ابعاد: " + data.item.dimension
                            : "") +
                          (data.item.weight
                            ? " / وزن: " + data.item.weight
                            : "") +
                          (data.item.producingCountry
                            ? " / محصول کشور: " + data.item.producingCountry
                            : "") +
                          (data.item.productionYear
                            ? "  / سال تولید: " + data.item.productionYear
                            : "") +
                          (data.item.contents
                            ? " / ترکیبات: " + data.item.contents
                            : "")
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(amount)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value.toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(price)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{
                          (
                            Number(data.item.amount) * data.item.price
                          ).toLocaleString()
                        }}
                      </div>
                    </template>
                  </b-table>
                  <div
                    style="padding: 10px 0 0; text-align: center"
                    v-if="printInvoice.useRoyaltyCredit"
                  >
                    <span style="font-size: 13px; font-weight: bold"
                      >در این خرید از اعتبار استفاده نموده‌اید.</span
                    >
                  </div>
                  <br />
                  <table
                    v-if="printInvoice.details"
                    style="
                      border: 0px solid black !important;
                      padding: 0 !important;
                      width: 100%;
                      margin-bottom: 10px;
                    "
                  >
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع اقلام:
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size: 16px"
                          >{{
                            printInvoice.details
                              .map((x) => Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr style="margin-bottom: 15px">
                      <td style="border: 0px solid black !important">
                        جمع کل (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size: 16px"
                          >{{
                            printInvoice.details
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0)
                              .toLocaleString()
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        !printInvoice.useRoyaltyCredit && printInvoice.discount
                      "
                      style="margin-bottom: 15px"
                    >
                      <td style="border: 0px solid black !important">
                        تخفیف (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size: 16px"
                          >{{ Number(printInvoice.discount).toLocaleString() }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      v-if="printInvoice.useRoyaltyCredit"
                      style="margin-bottom: 15px"
                    >
                      <td style="border: 0px solid black !important">
                        مبلغ اعتبار (تومان):
                      </td>
                      <td
                        style="
                          border: 0px solid black !important;
                          text-align: left;
                          padding: 0 !important;
                        "
                      >
                        <span style="font-size: 16px"
                          >{{
                            Number(
                              printInvoice.royaltyDiscount
                            ).toLocaleString()
                          }}
                        </span>
                      </td>
                    </tr>
                  </table>

                  <div class="totalCost" style="padding: 0px 10px !important">
                    <table
                      v-if="printInvoice.totalCost"
                      style="border: 0px solid black !important"
                    >
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          مبلغ قابل پرداخت (تومان):
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="
                            border: 0px solid black !important;
                            text-align: center;
                          "
                        >
                          <span style="font-size: 16px"
                            >{{
                              parseInt(printInvoice.totalCost).toLocaleString()
                            }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div class="mt-3" v-if="printInvoice.description != '-'">
                    توضیحات: {{ printInvoice.description }}
                  </div>
                  <br />
                  <div class="barcode-box">
                    <p style="text-align: center">(چاپ مجدد)</p>
                    <barcode
                      :value="printInvoice.code"
                      displayValue="false"
                      style="transform: translateX(50px)"
                    >
                    </barcode>
                  </div>
                  <div style="padding: 0 0 25px; text-align: center">
                    مرجوع کردن تا 72 ساعت پس از زمان خرید، با در دست داشتن این
                    فاکتور امکان پذیر است.
                  </div>
                  <div class="bot-box">
                    <div>از اینکه فروشگاه مارو انتخاب کردی خیلی ممنونیم (:</div>
                    <div>اینستاگرام: ace_pet_club</div>
                    <div>شماره تماس: 09124061268</div>
                    <div>
                      بلوار اندرزگو - بلوار صبا - کوچه کیارنک - نبش کوچه مقدم
                    </div>
                    <div>&nbsp;</div>
                    <div class="border-top">
                      کتاب باز همه روزه از ساعت ۱۱ صبح الی ۸ شب منتظر شماست!
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </div>
      </div>
    </v-card>
    <!-- receipt -->
    <br />
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueBarcode from "vue-barcode";
import moment from "moment-jalaali";
import MyCalendar from "../../components/MyCalendar.vue";
import { AtomSpinner, HalfCircleSpinner } from "epic-spinners";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    barcode: VueBarcode,
    MyCalendar,
    AtomSpinner,
    HalfCircleSpinner,
  },

  data: function () {
    return {
      guide: false,
      loading: false,
      whichPage: 1,
      types: ["همه", "ثبت شده", "برگشت خورده"],
      typeFilter: "",
      codeFilter: "",
      nameFilter: "",
      moment: moment,
      gettingReceipt: false,
      startDate: moment(new Date()).subtract(7, "days").format("jYYYY/jMM/jDD"),
      endDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      fields: [
        { key: "index", label: "ردیف" },
        { key: "shopCustomerName", label: "نام مشتری" },
        { key: "invoiceCode", label: "کد فاکتور" },
        { key: "date", label: "تاریخ" },
        { key: "time", label: "ساعت" },
        { key: "totalCost", label: "مبلغ" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      excelFields: [
        // { field: "index", label: "ردیف" },
        { field: "shopCustomerName", label: "نام مشتری" },
        { field: "invoiceCode", label: "کد فاکتور" },
        { field: "date", label: "تاریخ" },
        { field: "time", label: "ساعت" },
        { field: "totalCost", label: "مبلغ" },
        { field: "status", label: "وضعیت" },
      ],
      invoiceTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      invoiceType: "definite",
      selectedFields: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "نام کالا" },
        { key: "price", label: "قیمت واحد (تومان)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "جمع کل (تومان)" },
      ],
      TotalRows: "",
      customers: [],
      customerName: "",
      customerPriority: "",
      customerMobile: "",
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      T: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      busy: false,
      filter: "",
      invoices: [],
      selected: "",
      newInvoice: {
        customerBalance: "",
      },
      progress: false,
      customer: {},
      printInvoice: {
        shopCustomerName: "",
      },
      returnModal: false,
      reactivity: false,
      returnAmount: null,
      calculateLoading: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    goToEditInvoicePage(item) {
      this.$router.push("/shop/editinvoice/" + item.id);
    },
    openModal(item) {
      this.returnModal = true;
      this.selected = item;
    },
    calculateReturnAmount(item) {
      this.calculateLoading = true;
      this.openModal(item);

      Axios.get(
        this.baseUrl + "/satrapp/shop/sales/calculateReturnAmount/" + item.id,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )

        .then((res) => {
          if (res.status == 200) {
            this.returnAmount = res.data;
            this.toast(res.data.message + "success");
            this.calculateLoading = false;
          }
        })
        .catch((err) => {
          this.calculateLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getStartDate(value) {
      this.startDate = value;
    },
    getEndDate(value) {
      this.endDate = value;
    },
    print(item, forcePrint) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
            setTimeout(() => {
              this.printReceipt();
            }, 1000);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "Receipt", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><link rel='stylesheet' href='/receipt.css'><title>Receipt</title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("Receipt").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    goToId(item) {
      let link = "/shop/invoice/" + item.id;
      window.open(link, "_blank");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    delFilter() {
      // this.sortBy = "";
      this.userInput = "";
      // this.searchInvoices();
    },
    getBalance(customerId) {
      this.newInvoice.customerBalance = "";
      Axios.post(
        this.baseUrl + "/satrapp/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newInvoice.customerBalance = Number(
              res.data.balance.split(",").join("")
            );
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " تومان بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " تومان بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addInvoice() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/new",
        {
          shopCustomerId: this.newInvoice.shopCustomerId,
          type: this.newInvoice.type,
          totalCost: this.newInvoice.totalCost,
          itemIds: this.newInvoice.itemIds,
          details: this.newInvoice.details,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newInvoice = {};
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submit() {
      this.busy = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/return/" + this.selected.id,
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.returnModal = false;
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    editCustomer() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          email: this.customer.email,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.customerName = "";
            this.customerPriority = "";
            this.customerEmail = "";
            this.customerMobile = "";
            this.searchInvoices();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getCustomerInfo() {
      this.progress = true;
      Axios.post(
        this.baseUrl + "/satrapp/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customer.name = res.data.name;
            this.customer.mobile = res.data.mobile;
            this.customer.email = res.data.email;
            this.customer.economicCode = res.data.economicCode;
            this.customer.phone = res.data.phone;
            this.customer.address = res.data.address;
            this.customer.natCode = res.data.natCode;
            this.customer.type = res.data.type;
            this.customer.balance = res.data.balance;
            this.progress = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showCustomerDialog(customer) {
      this.customerDialog = true;
      this.customerName = "";
      this.selected = customer;
      this.getCustomerInfo();
    },
    searchInvoices() {
      this.loading = true;
      this.currentPage = 1;
      Axios.post(
        this.baseUrl + "/satrapp/shop/sales/invoices",
        {
          type: this.invoiceType,
          startDate: this.startDate + "00:00",
          endDate: this.endDate + "23:59",
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.invoices = res.data;
            this.TotalRows = this.invoices.length;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    getCustomers() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    getProducts() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customers = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    totalCost() {
      return 1000;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedInvoices.length;
      let arrlength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrlength; i++) {
        arr.push(i);
      }
      return arr;
    },
    computedFilterDate() {
      let date =
        "از تاریخ " +
        this.startDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.startDate.split("/")[1]) +
        "/" +
        this.startDate.split("/")[0] +
        " تا تاریخ " +
        this.endDate.split("/")[2] +
        "/" +
        this.persianMonthName(this.endDate.split("/")[1]) +
        "/" +
        this.endDate.split("/")[0];

      return date;
    },
    computedInvoices() {
      let filtered;
      if (this.typeFilter == "همه") {
        filtered = this.invoices.filter(
          (x) =>
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      } else {
        filtered = this.invoices.filter(
          (x) =>
            x.status == this.typeFilter &&
            x.shopCustomerName.includes(this.nameFilter) &&
            x.invoiceCode.toLowerCase().includes(this.codeFilter.toLowerCase())
        );
      }
      return filtered;
    },
  },

  mounted() {
    this.searchInvoices();
    this.getCustomers();
  },
};
</script>

<style lang="scss">
.v-select .v-input__slot fieldset {
  background-color: white !important;
}
.v-menu__content {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  margin-top: 10px;
}
.invoices {
  .custom-input {
    .v-input__slot {
      width: 210px !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #7c4dff !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
  .customSelect2 {
    .v-input__slot {
      width: 100% !important;
    }
    .v-select__selection--comma {
      font-size: 14px !important;
    }
  }
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;
}
</style>
<style scoped>
thead {
  background-color: white;
  color: black;
}
@media print {
  td {
    font-family: "iranyekan" !important;
    border-radius: 3px;
  }
  @page {
    size: A5 landscape;
    font-size: 30%;
    text-color: black;
  }

  table.mainTable {
    border: 0px !important;
  }
}
</style>
